import { BadgeProps } from '@chakra-ui/react';

import { DeliverableStatusKeyGQLType } from 'types/dashboard-core-gqlTypes.generated';

export const deliverableStatusLabelDEPRECATED: {
  [status in DeliverableStatusKeyGQLType]: {
    borderColor: string; // indicator border color
    color: string; // indicator fill color
    colorScheme: BadgeProps['colorScheme']; // color for badges
    isSelectOption: boolean;
    label: string;
    value: DeliverableStatusKeyGQLType;
  };
} = {
  notStarted: {
    borderColor: 'blue.300',
    color: 'transparent',
    colorScheme: 'blue',
    isSelectOption: true,
    value: 'notStarted',
    label: 'Not submitted',
  },
  upcoming: {
    borderColor: 'blue.300',
    color: 'transparent',
    colorScheme: 'blue',
    isSelectOption: false,
    value: 'upcoming',
    label: 'Upcoming',
  },
  dueSoon: {
    borderColor: 'orange.300',
    color: 'transparent',
    colorScheme: 'orange',
    isSelectOption: false,
    value: 'dueSoon',
    label: 'Due soon',
  },
  overdue: {
    borderColor: 'red.300',
    color: 'transparent',
    colorScheme: 'red',
    isSelectOption: false,
    value: 'overdue',
    label: 'Overdue',
  },
  expired: {
    borderColor: 'red.300',
    color: 'transparent',
    colorScheme: 'red',
    isSelectOption: false,
    value: 'expired',
    label: 'Expired',
  },
  waived: {
    borderColor: 'gray.300',
    color: 'gray.300',
    colorScheme: 'gray',
    isSelectOption: true,
    value: 'waived',
    label: 'Waived',
  },
  completed: {
    borderColor: 'green.300',
    color: 'green.300',
    colorScheme: 'green',
    isSelectOption: true,
    value: 'completed',
    label: 'Completed',
  },
};
